module.exports = __webpack_public_path__ + "static/media/dside-bill.d98eab4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyPages/Forge/dside-bill.svg
// module id = 1055
// module chunks = 0